export class PatientAddress {
    id: number;
    userId: number | null;
    active: boolean = true;
    type: string;
    isBilling: boolean | null;
    isMailing: boolean | null;
    line: string;
    line2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
    country: string;
    startDate: string | null;
    endDate: string | null;
    createdDate: string | null;
    modifiedDate: string | null;
}
